<!-- start page title -->
<app-pagetitle title="Dashboard" ></app-pagetitle>
<div >
  @if (showTimekeeperDashboard) {
    <app-timekeeper-dashboard></app-timekeeper-dashboard>
  }
  @if (showLpcDashboard) {
    <app-lpc-dashboard></app-lpc-dashboard>
  }
  <app-notification-center></app-notification-center>
</div>

<div class="row" >
  <div class="col-lg-12">
    <div class="card">
      <div class="card-header">
        <div class="row mb-1">
          <div class="col-sm-10">
            <p class="text-muted text-uppercase fw-semibold">Widgets</p>
          </div>
          <div class="col-sm-1" style="top: -2%;width: 2%;">
            @if (isWidgetsLoading) {
              <span class="pageLoader">
                <div class="loading-spinner"></div>
              </span>
            }
          </div>
          <div class="col-sm-2" style="display: inline-block;width: 14%;padding-right: 0px;">
            <span style="float: right;"><button class="btn btn-primary" (click)="openWidgetModal()"><i
            class="mdi mdi-pencil"></i> Manage Widgets</button></span>
          </div>
        </div>
      </div>
      <div class="card-body">
        <!-- Dynamic Chart Grid - 2 charts per row -->
        <div class="row chart-row">
          @for (chart of visibleCharts; track chart; let i = $index) {
            <!-- Full width chart (Open Task Due Date) -->
            @if (chart.fullWidth) {
              <div class="col-12 chart-column mb-3">
                <div class="card h-100">
                  <div class="card-header">
                    <p class="text-muted text-uppercase fw-semibold mb-0">{{chart.title}}</p>
                  </div>
                  <div class="card-body chart-container circular-chart">
                    <ngx-charts-advanced-pie-chart
                      [view]="chartConfigs[0].view"
                      [scheme]="chartConfigs[0].colorScheme"
                      [results]="chartConfigs[0].data"
                      [animations]="chartConfigs[0].animations"
                      (select)="onSelect($event)"
                      (activate)="onActivate($event)"
                      (deactivate)="onDeactivate($event)">
                    </ngx-charts-advanced-pie-chart>
                  </div>
                </div>
              </div>
            }
            <!-- Half width charts (2 per row) -->
            @if (!chart.fullWidth) {
              <div class="col-md-6 chart-column mb-3">
                <div class="card h-100">
                  <div class="card-header d-flex justify-content-between align-items-center">
                    <p class="text-muted text-uppercase fw-semibold mb-0">{{chart.title}}</p>
                    @if (chart.filterKey) {
                      <button class="filter-toggle-btn" (click)="toggleFilter(chart.filterKey)">
                        <i class="bx" [ngClass]="{'bx-filter': !showFilters[chart.filterKey], 'bx-x': showFilters[chart.filterKey]}"></i>
                      </button>
                    }
                  </div>
                  <div class="card-body chart-container">
                    <!-- Projects by LPA -->
                    @if (chart.component === 'projects-by-lpa') {
                      <app-projects-by-lpa
                        [isFilterVisible]="showFilters[chart.filterKey]">
                      </app-projects-by-lpa>
                    }
                    <!-- Tasks by LPA -->
                    @if (chart.component === 'tasks-by-lpa') {
                      <app-tasks-by-lpa
                        [isFilterVisible]="showFilters[chart.filterKey]">
                      </app-tasks-by-lpa>
                    }
                    <!-- Open and Closed Revenues -->
                    @if (chart.component === 'open-and-closed-revenues') {
                      <app-open-and-closed-revenues
                        [isFilterVisible]="showFilters[chart.filterKey]">
                      </app-open-and-closed-revenues>
                    }
                    <!-- Project Duration -->
                    @if (chart.component === 'project-duration') {
                      <app-project-duration
                        [isFilterVisible]="showFilters[chart.filterKey]">
                      </app-project-duration>
                    }
                    <!-- Capacity by Person -->
                    @if (chart.component === 'capacity-by-person') {
                      <app-capacity-by-person
                        [isFilterVisible]="showFilters[chart.filterKey]">
                      </app-capacity-by-person>
                    }
                    <!-- Tasks by Practice Area -->
                    @if (chart.component === 'tasks-by-practice-area') {
                      <app-tasks-by-practice-area
                        [isFilterVisible]="showFilters[chart.filterKey]">
                      </app-tasks-by-practice-area>
                    }
                    <!-- Tasks Due -->
                    @if (chart.component === 'tasks-due') {
                      <app-tasks-due
                        [isFilterVisible]="showFilters[chart.filterKey]">
                      </app-tasks-due>
                    }
                    <!-- Time Distribution -->
                    @if (chart.component === 'time-distribution') {
                      <app-time-distribution
                        [isFilterVisible]="showFilters[chart.filterKey]">
                      </app-time-distribution>
                    }
                  </div>
                </div>
              </div>
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>



<p-dialog [resizable]="false" [draggable]="false" [(visible)]="widgetDialog" (onHide)="closeDialog()"
  [style]="{'width': '80%', 'max-height':'85%'}" header="Manage Widgets" [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="content">
    <app-notification [errorMsg]="errorMsg"></app-notification>
    <app-items-selector></app-items-selector>
  </ng-template>
</p-dialog>